import { render } from "./Messages.vue?vue&type=template&id=403b93a0&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=403b93a0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ThinleyNorbu\\source\\repos\\1185_BF_Module_0\\vueOktaVersion\\custom-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403b93a0"]])

export default __exports__